import { TestCaseService } from '@/api/testCase';
import { Dialog } from 'alurkerja-ui';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { MdCloudDownload } from 'react-icons/md';
import { downloadFile } from '@/utils/libs/fileUtil';

type ExportTestCaseProps = {
  id?: string;
  projectName?: string;
};

export const ExportTestCase: React.FC<ExportTestCaseProps> = ({
  id,
  projectName,
}) => {
  const { mutate: exportMutate, isPending: isExportLoading } =
    TestCaseService.useExport();

  const exportAction = (id: string) => {
    exportMutate(id, {
      onSuccess: response => {
        Dialog.success({
          title: 'Success',
          description: 'Test case has been exported',
        });

        downloadFile(response, `TestCases_${projectName}.xlsx`);
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to export test case',
        });
      },
    });
  };

  return (
    <OutlineButton
      icon={<MdCloudDownload />}
      onClick={() => exportAction(id!)}
      isLoading={isExportLoading}
    >
      Export
    </OutlineButton>
  );
};
